import theme from '../../theme/theme';

const {
  colors: { black_text, subtitle },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    paddingRight: '1.125em',
    height: '5.750em',
    paddingLeft: '1.9em',
  },

  title__container: {
    paddingLeft: '0.6em',
    paddingBottom: '.6em',
  },

  title: {
    color: black_text,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
  },

  subtitle__text: {
    color: subtitle,
    fontSize: '1.250em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
  },

  plus__sign: {
    position: 'absolute',
    right: 0,
    paddingTop: '1.35em',
    paddingRight: '2em',
  },
};

export default styles;
